import { render, staticRenderFns } from "./FinalDecisionOnLeaveToAppealRspToLeaveRefusedPg.vue?vue&type=template&id=211914b7&scoped=true"
import script from "./FinalDecisionOnLeaveToAppealRspToLeaveRefusedPg.vue?vue&type=script&lang=ts"
export * from "./FinalDecisionOnLeaveToAppealRspToLeaveRefusedPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211914b7",
  null
  
)

export default component.exports